<template>
    <modal @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            Add Tax Reciprocal Agreement
        </template>

        <slot>
            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row">
                    <div class="col">
                        <form-input
                            v-model="formData.work_location_tax"
                            :errors="errors.work_location_tax"
                            type="select"
                            label="Work Location Tax"
                            :options="symTaxOptions"
                        />
                    </div>
                </div>

                <div class="form-row">
                    <div class="col">
                        <form-input
                            v-model="formData.resident_location_tax"
                            :errors="errors.resident_location_tax"
                            type="select"
                            label="Resident Location Tax"
                            :options="symTaxOptions"
                        />
                    </div>
                </div>
            </form>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row>
                <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    mixins: [FormMixin, ModalMixin],
    computed: {
        symTaxOptions() {
            return this.symTaxes.map(t => ({
                text: t.description,
                value: t.id,
            }))
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            symTaxes: [],
        }
    },
    mounted() {
        this.$store.dispatch('START_LOADING')
        this.$api.get('/admin/tax-engine/sym-taxes', {state: ''}).then(resp => {
            this.symTaxes = resp.filter(t => t.tax_type === 'SIT')
            this.$store.dispatch('STOP_LOADING')
        }).catch(errors => {
            this.$store.dispatch('STOP_LOADING')
            this.$bus.showError(errors.__all__)
        })
    },
    methods: {
        makeFormData() {
            return {
                work_location_tax: null,
                resident_location_tax: null,
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            this.$api.post('/admin/tax-engine/tax-reciprocal-agreements', this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    },
}
</script>
